import React from 'react';

export default function MinimalTemplate({ resumeData }) {
	const s = resumeData.sections || {};
	return (
		<div className="p-10 text-[13px] text-gray-900">
			<h1 className="text-3xl font-light tracking-wide">{s.personalInfo?.name || 'Your Name'}</h1>
			<p className="text-xs text-gray-500 mt-1">
				{s.personalInfo?.email || ''} {s.personalInfo?.phone ? '• ' + s.personalInfo?.phone : ''}{' '}
				{s.personalInfo?.location ? '• ' + s.personalInfo?.location : ''}
			</p>
			<div className="mt-6 space-y-6">
				{s.personalInfo?.summary && (
					<section>
						<h2 className="uppercase tracking-widest text-xs text-gray-500">Summary</h2>
						<p className="mt-1">{s.personalInfo.summary}</p>
					</section>
				)}
				{Array.isArray(s.experience) && s.experience.length > 0 && (
					<section>
						<h2 className="uppercase tracking-widest text-xs text-gray-500">Experience</h2>
						<div className="mt-1 space-y-3">
							{s.experience.map((e, i) => (
								<div key={i}>
									<p className="font-medium">{e.position} • {e.company}</p>
									{e.description && <p className="text-sm text-gray-700">{e.description}</p>}
								</div>
							))}
						</div>
					</section>
				)}
				{Array.isArray(s.education) && s.education.length > 0 && (
					<section>
						<h2 className="uppercase tracking-widest text-xs text-gray-500">Education</h2>
						<div className="mt-1 space-y-2">
							{s.education.map((ed, i) => (
								<div key={i}>
									<p className="font-medium">{ed.degree} • {ed.institution}</p>
									{ed.field && <p className="text-sm">{ed.field}</p>}
								</div>
							))}
						</div>
					</section>
				)}
				{Array.isArray(s.skills) && s.skills.length > 0 && (
					<section>
						<h2 className="uppercase tracking-widest text-xs text-gray-500">Skills</h2>
						<ul className="mt-1 list-disc ml-5">
							{s.skills.map((cat, i) => (
								<li key={i}>
									<span className="font-medium">{cat.category}:</span> {(cat.items || []).join(', ')}
								</li>
							))}
						</ul>
					</section>
				)}
			</div>
		</div>
	);
}


